<template>
  <div>
    <div>
      <v-layout wrap>
        <v-flex xs6 style="display: flex" align-center
          ><h3>{{ $t('salesforce_connect.title') }}</h3></v-flex
        >
        <v-flex xs6 style="display: flex" justify-end>
          <v-btn fab outline color="primary" class="extra-small ma-1" @click="handleEditQueueName">
            <i class="fas fa-pencil-alt"></i>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
    <div
      :style="{
        border: `1px solid ${$vuetify.theme.primary}`
      }"
      class="pa-3 my-3"
    >
      <div>
        <h4>{{ $t('salesforce_connect.create_case') }}</h4>
      </div>
      <div class="form-control">
        <div class="caption mb-1 mt-2">{{ $t('salesforce_connect.queue_name') }}</div>
        <input
          v-model="create_case.queue_name"
          type="text"
          :placeholder="$t('salesforce_connect.queue_name')"
          class="form-control"
          maxlength="255"
          :disabled="!isEdit"
        />
      </div>
      <div class="form-control">
        <div class="caption mb-1 mt-2">{{ $t('salesforce_connect.subject') }}</div>
        <input
          v-model="create_case.subject"
          type="text"
          :placeholder="$t('salesforce_connect.subject')"
          class="form-control"
          maxlength="255"
          :disabled="!isEdit"
        />
      </div>
    </div>
    <div
      :style="{
        border: `1px solid ${$vuetify.theme.primary}`
      }"
      class="pa-3 my-3"
    >
      <div>
        <h4>{{ $t('salesforce_connect.reassign_queue') }}</h4>
      </div>
      <div class="form-control">
        <div class="caption mb-1 mt-2">{{ $t('salesforce_connect.queue_name') }}</div>
        <input
          v-model="reassign_queue.queue_name"
          type="text"
          :placeholder="$t('salesforce_connect.queue_name')"
          class="form-control"
          maxlength="255"
          :disabled="!isEdit"
        />
      </div>
    </div>
    <div
      :style="{
        border: `1px solid ${$vuetify.theme.primary}`
      }"
      class="pa-3 my-3"
    >
      <div>
        <h4>{{ $t('salesforce_connect.create_opportunity') }}</h4>
      </div>
      <div class="form-control">
        <div class="caption mb-1 mt-2">{{ $t('salesforce_connect.queue_name') }}</div>
        <input
          v-model="create_opportunity.queue_name"
          type="text"
          :placeholder="$t('salesforce_connect.queue_name')"
          class="form-control"
          maxlength="255"
          :disabled="!isEdit"
        />
      </div>
      <div class="form-control">
        <div class="caption mb-1 mt-2">{{ $t('salesforce_connect.opportunity_name') }}</div>
        <input
          v-model="create_opportunity.opportunity_name"
          type="text"
          :placeholder="$t('salesforce_connect.opportunity_name')"
          class="form-control"
          maxlength="255"
          :disabled="!isEdit"
        />
      </div>
    </div>
    <div
      :style="{
        border: `1px solid ${$vuetify.theme.primary}`
      }"
      class="pa-3 my-3"
    >
      <div>
        <h4>{{ $t('salesforce_connect.close_chat') }}</h4>
      </div>
      <div class="form-control">
        <div class="caption mb-1 mt-2">{{ $t('salesforce_connect.close_chat') }}</div>
        <input
          v-model="close_chat.queue_name"
          type="text"
          :placeholder="$t('salesforce_connect.close_chat')"
          class="form-control"
          maxlength="255"
          :disabled="!isEdit"
        />
      </div>
    </div>
    <template v-if="isEdit === true">
      <div class="text-xs-center mt-3">
        <v-btn outline color="grey" :loading="saveLoading" @click="handleCancel">{{
          $t('cancel')
        }}</v-btn>
        <v-btn color="primary" depressed :loading="saveLoading" @click="handleSubmit">{{
          $t('Save')
        }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import cmsConfig from '@/api/config'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      create_case: {
        queue_name: '',
        subject: ''
      },
      reassign_queue: {
        queue_name: ''
      },
      create_opportunity: {
        queue_name: '',
        opportunity_name: ''
      },
      close_chat: {
        queue_name: ''
      },
      isEdit: false,
      saveLoading: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    selectedBot(data) {
      this.handlePrefillForm(data)
    }
  },
  async mounted() {
    await this.$store.dispatch('updateBotDetail')
  },
  methods: {
    handlePrefillForm(data) {
      try {
        const tempData = data.page_custom_attributes_json.central_cds_salesforce_action

        this.create_case = {
          queue_name: tempData.CREATE_CASE.queue_name,
          subject: tempData.CREATE_CASE.subject
        }
        this.reassign_queue = {
          queue_name: tempData.REASSIGN_QUEUE.queue_name
        }
        this.create_opportunity = {
          queue_name: tempData.CREATE_OPPORTUNITY.queue_name,
          opportunity_name: tempData.CREATE_OPPORTUNITY.opportunity_name
        }
        this.close_chat = {
          queue_name: tempData.CLOSE_CHAT.queue_name
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleEditQueueName() {
      this.isEdit = true
    },
    handleCancel() {
      this.isEdit = false
    },
    async handleSubmit() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await cmsConfig.updatePageCustomAttributes({
          params: {
            pageId: vm.selectedBot.pageid
          },
          data: {
            page_custom_attributes_json: {
              central_cds_salesforce_action: {
                CREATE_CASE: {
                  subject: vm.create_case.subject,
                  queue_name: vm.create_case.queue_name
                },
                REASSIGN_QUEUE: {
                  queue_name: vm.reassign_queue.queue_name
                },
                CREATE_OPPORTUNITY: {
                  queue_name: vm.create_opportunity.queue_name,
                  opportunity_name: vm.create_opportunity.opportunity_name
                },
                CLOSE_CHAT: {
                  queue_name: vm.close_chat.queue_name
                }
              }
            }
          }
        })
        const { status } = response
        if (status === 204) {
          vm.$swal.fire({
            type: 'success',
            title: vm.$t('Success')
          })
        }
      } catch (error) {
        console.error(error)
        vm.$swal.fire({
          type: 'error',
          title: vm.$t('Unsuccessful')
        })
      } finally {
        vm.$store.dispatch('updateBotDetail')
        vm.$store.dispatch('loading')
        vm.isEdit = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/SalesforceConnectManagement.vue